// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-layout {
  display: flex;
  height: 100vh;
  width: 100vw;
  background-color: #ffffff;
  /* Back to Pure White */
  color: var(--text-color);
  overflow: hidden;
  position: relative;
}

/* Watermark styles removed */

/* Animations removed per user request for static focus look */

/* Watermark - Pure Black and Red Theme Treatment */
.watermark-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  max-width: 500px;
  z-index: 0;
  pointer-events: none;
  opacity: 0.05;
  /* Even more subtle for gray theme */
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.5s ease;
}

.watermark-logo {
  width: 100%;
  height: auto;
  opacity: 1;
}


/* Sidebar styles removed */

.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: transparent;
  /* Show watermark */
  width: 100%;
  position: relative;
  z-index: 1;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 40px;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  z-index: 10;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-logo {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1.5px solid var(--primary-color);
  margin-right: 15px;
  background: white;
}

.header-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--primary-color);
  text-transform: uppercase;
  letter-spacing: 1.2px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logout-btn,
.faq-btn {
  background: transparent;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  padding: 8px 18px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.logout-btn:hover,
.faq-btn:hover {
  background: var(--primary-color);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.chat-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  overflow: hidden;
  position: relative;
}

#queryAns-main-container {
  flex: 1 1;
  overflow-y: auto;
  margin-bottom: 20px;
  scrollbar-width: thin;
  scrollbar-color: var(--primary-color) transparent;
}

/* Enhancing scrollbar */
#queryAns-main-container::-webkit-scrollbar {
  width: 6px;
}

#queryAns-main-container::-webkit-scrollbar-thumb {
  background-color: var(--primary-color);
  border-radius: 10px;
}

.input-area {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

#searchbar {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/chat/chat.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,6BAA6B;;AAE7B,8DAA8D;;AAE9D,mDAAmD;AACnD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;;AAGA,2BAA2B;;AAE3B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;;EAEE,gCAAgC;EAChC,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA,wBAAwB;AACxB;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb","sourcesContent":[".chat-layout {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  background-color: #ffffff;\n  /* Back to Pure White */\n  color: var(--text-color);\n  overflow: hidden;\n  position: relative;\n}\n\n/* Watermark styles removed */\n\n/* Animations removed per user request for static focus look */\n\n/* Watermark - Pure Black and Red Theme Treatment */\n.watermark-container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 50%;\n  max-width: 500px;\n  z-index: 0;\n  pointer-events: none;\n  opacity: 0.05;\n  /* Even more subtle for gray theme */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: opacity 0.5s ease;\n}\n\n.watermark-logo {\n  width: 100%;\n  height: auto;\n  opacity: 1;\n}\n\n\n/* Sidebar styles removed */\n\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: transparent;\n  /* Show watermark */\n  width: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 40px;\n  background-color: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  z-index: 10;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n}\n\n.header-logo {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  border: 1.5px solid var(--primary-color);\n  margin-right: 15px;\n  background: white;\n}\n\n.header-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--primary-color);\n  text-transform: uppercase;\n  letter-spacing: 1.2px;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.logout-btn,\n.faq-btn {\n  background: transparent;\n  border: 1px solid var(--primary-color);\n  color: var(--primary-color);\n  padding: 8px 18px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.logout-btn:hover,\n.faq-btn:hover {\n  background: var(--primary-color);\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.chat-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 40px;\n  overflow: hidden;\n  position: relative;\n}\n\n#queryAns-main-container {\n  flex: 1;\n  overflow-y: auto;\n  margin-bottom: 20px;\n  scrollbar-width: thin;\n  scrollbar-color: var(--primary-color) transparent;\n}\n\n/* Enhancing scrollbar */\n#queryAns-main-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n#queryAns-main-container::-webkit-scrollbar-thumb {\n  background-color: var(--primary-color);\n  border-radius: 10px;\n}\n\n.input-area {\n  margin-top: auto;\n  padding-top: 20px;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n#searchbar {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
